






































import Vue from 'vue';
import PlaylistsPanelStudentItemCard from '@/web/components/products/PlaylistsPanelStudentItemCard';
import { BCollapse } from 'bootstrap-vue';
import RightBlockSourceType from '@/core/typings/enums/RightBlockSourceType';

export default Vue.extend({
  name: 'StudioNonMediaDetailsSidebar',
  components: {
    PlaylistsPanelStudentItemCard,
    BCollapse,
  },
  props: {
    sourceTitle: {
      type: String,
    },
    playlist: {
      type: Object,
    },
  },
  data() {
    return {
      isExpanded: true,
      lessonMediaCount: 1,
    };
  },
  computed: {
    getSource() {
      return RightBlockSourceType;
    },
  },
});
